"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXItemStruct = exports.HTMLItemStruct = exports.HTMLItemStructCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const table_1 = require("./table");
const remarks_1 = require("./remarks");
const noteLike_1 = require("./noteLike");
const figRun_1 = require("./figRun");
const common_1 = require("../common");
exports.HTMLItemStructCSS = `
.item-struct {
    clear: both;
}

.item-struct-title {
    clear: both;
    font-weight: bold;
}

`;
exports.HTMLItemStruct = (0, html_1.wrapHTMLComponent)("HTMLItemStruct", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const ItemStructTitle = el.children.find(el => (std.isTableStructTitle(el)
        || std.isFigStructTitle(el)
        || std.isNoteStructTitle(el)
        || std.isFormatStructTitle(el)
        || std.isStyleStructTitle(el)));
    if (ItemStructTitle) {
        blocks.push((react_1.default.createElement("div", { className: `item-struct-title indent-${indent}`, ...(0, html_1.elProps)(ItemStructTitle, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ItemStructTitle.children, htmlOptions }))));
    }
    const bodyBlocks = [];
    for (const child of el.children) {
        if (std.isTableStructTitle(child)
            || std.isFigStructTitle(child)
            || std.isNoteStructTitle(child)
            || std.isFormatStructTitle(child)
            || std.isStyleStructTitle(child)) {
            continue;
        }
        else if (std.isRemarks(child)) {
            bodyBlocks.push(react_1.default.createElement(remarks_1.HTMLRemarks, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isTable(child)) {
            bodyBlocks.push(react_1.default.createElement(table_1.HTMLTable, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isFig(child)) {
            bodyBlocks.push((react_1.default.createElement("div", { className: `item-struct-runs indent-${indent}` },
                react_1.default.createElement(figRun_1.HTMLFigRun, { el: child, htmlOptions }))));
        }
        else if (std.isNoteLike(child)) {
            bodyBlocks.push(react_1.default.createElement(noteLike_1.HTMLNoteLike, { el: child, indent: indent, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push((react_1.default.createElement("div", { className: "item-struct-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "item-struct", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXItemStruct = (0, component_1.wrapDOCXComponent)("DOCXItemStruct", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const ItemStructTitle = el.children.find(el => (std.isTableStructTitle(el)
        || std.isFigStructTitle(el)
        || std.isNoteStructTitle(el)
        || std.isFormatStructTitle(el)
        || std.isStyleStructTitle(el)));
    const hasFig = Boolean(el.children.find(c => std.isFig(c) || (std.isNoteLike(c) && c.children.length !== 0 && std.isFig(c.children[0]))));
    if (ItemStructTitle) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` }),
                hasFig && react_1.default.createElement(tags_1.w.keepNext, null),
                hasFig && react_1.default.createElement(tags_1.w.keepLines, null)),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ItemStructTitle.children, emphasis: true, docxOptions }))));
    }
    for (const child of el.children) {
        if (std.isTableStructTitle(child)
            || std.isFigStructTitle(child)
            || std.isNoteStructTitle(child)
            || std.isFormatStructTitle(child)
            || std.isStyleStructTitle(child)) {
            continue;
        }
        else if (std.isRemarks(child)) {
            blocks.push(react_1.default.createElement(remarks_1.DOCXRemarks, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isTable(child)) {
            blocks.push(react_1.default.createElement(table_1.DOCXTable, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isFig(child)) {
            blocks.push(react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(figRun_1.DOCXFigRun, { el: child, docxOptions })));
        }
        else if (std.isNoteLike(child)) {
            blocks.push(react_1.default.createElement(noteLike_1.DOCXNoteLike, { el: child, indent: indent, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=itemStruct.js.map